import {
  Briefcase,
  GraduationCap,
  Megaphone,
  FileText,
  Package,
  Truck,
  Landmark,
} from "lucide-react";

export const CONTACT_EMAIL = "support@iconicho.com";

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Capabilities", to: "/#capabilities" },
  { label: "Government Contracting", to: "/government-contracting" },
  { label: "Business Solutions", to: "/business-solutions" },
  { label: "Contact", to: "/contact" },
];

export const CAPABILITIES = [
  {
    icon: Briefcase,
    title: "Business Consulting & Management",
    description:
      "Business strategy, management support, operational guidance, process improvement, and organizational solutions.",
  },
  {
    icon: GraduationCap,
    title: "Leadership & Professional Development",
    description:
      "Leadership training, professional development, workforce education, and organizational training programs.",
  },
  {
    icon: Megaphone,
    title: "Marketing & Business Development",
    description:
      "Marketing strategy, brand development, business development support, digital marketing, and related services.",
  },
  {
    icon: FileText,
    title: "Administrative & Business Support",
    description:
      "Administrative support, documentation, coordination, business operations support, and other professional services.",
  },
  {
    icon: Package,
    title: "Procurement & Supply",
    description:
      "Procurement support, sourcing, product and material supply, fulfillment, and related purchasing solutions.",
  },
  {
    icon: Truck,
    title: "Logistics & Delivery",
    description:
      "Delivery coordination, logistics support, transportation-related services, and fulfillment solutions.",
  },
  {
    icon: Landmark,
    title: "Government Contracting",
    description:
      "Professional services, supplies, support services, and other solutions for government agencies and contracting partners.",
  },
];

export const INQUIRY_TYPES = [
  "Government Contracting",
  "Subcontracting / Partnership",
  "Business Services",
  "Procurement / Supply",
  "Logistics",
  "Training",
  "Marketing",
  "General Inquiry",
];

export const CREDIBILITY = [
  {
    title: "Diversified Capabilities",
    text: "Multiple business solution categories allow Iconicho to pursue a broad range of opportunities.",
  },
  {
    title: "Adaptable Solutions",
    text: "Services can be structured around the needs and requirements of each organization or engagement.",
  },
  {
    title: "Professional Execution",
    text: "Iconicho approaches every engagement with an emphasis on communication, organization, accountability, and execution.",
  },
  {
    title: "Built for Growth",
    text: "The company is structured to expand its capabilities, partnerships, and contracting opportunities over time.",
  },
];

export const DIVISIONS = [
  {
    name: "Accelerate Tax & Credit",
    description:
      "Tax, business credit, business formation, and related business services.",
    url: "https://www.acceleratetaxandcredit.com",
    cta: "Visit Accelerate Tax & Credit",
    testId: "division-card-tax",
  },
  {
    name: "Accelerate Marketing",
    description:
      "Marketing, lead generation, brand development, and related marketing services.",
    url: "https://www.getacceleratemarketing.com",
    cta: "Visit Accelerate Marketing",
    testId: "division-card-marketing",
  },
];

export const MARQUEE_ITEMS = [
  "Business Consulting",
  "Government Contracting",
  "Procurement & Supply",
  "Logistics & Delivery",
  "Leadership Development",
  "Marketing & Brand",
  "Administrative Support",
  "Professional Services",
];
